<template>
    <div class="row">
        <div class="col-12">
            <h2>{{ legalMentions.guaranteeTitle }}</h2>
            <div id="anchor-guarantee-legal-mentions">
                <p class="mb-1" v-html="legalMentions.guaranteeText" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "GuaranteeLegalMentions",
    props: {
        legalMentions: {
            type: Object,
            required: true
        }
    },
}
</script>
